import React, { useContext } from 'react'

import './index.scss';
import moment from 'moment';
import { 
    HomeContext, 
    ModalContext 
} from 'contexts';
export const LatestEvent = ({ trackerEvent = {}, tracker = [], trackPoint = [], trackerObject = {} }) => {
    const { setPortInfo } = useContext(ModalContext);
    const { setChoosePol, setChoosePod } = useContext(HomeContext);
    const { locations, vessels } = tracker;

    const trackerArray = () => {
        let resultTracker = []
        let pol = {};
        const locationPol = locations?.find(e => e.id === 1);
        pol.location = locationPol;
        pol.vessel = vessels?.find(item => trackPoint?.some(v => (v?.imo === item?.imo && v?.point1 === locationPol?.locode)));
        pol.icon = 'icon-anchor port';
        pol.portInfo =  trackerEvent?.pol?.portInfo;
        pol.dateLocation = trackerEvent?.pol?.vesselArriver;
        pol.showPortInfo = true;
        pol.statusLocation = trackerEvent?.pol?.vesselArriver ? (new Date() < new Date(trackerEvent?.pol?.vesselArriver) ? 'Estimated' : 'Actual') : '-';
        pol.port = "Arrival";

        let departure = {};
        departure.icon = 'icon-ship port small-ship';
        departure.portInfo =  trackerEvent?.pol?.portInfo;
        departure.port = "Departure"; 
        departure.showPortInfo = true;
        departure.dateLocation = trackerEvent?.pol?.vesselDeparture;
        departure.dateVessel = trackerEvent?.pol?.originDeparture;
        departure.statusLocation = trackerEvent?.pol?.vesselDeparture ? (new Date() < new Date(trackerEvent?.pol?.vesselDeparture) ? 'Estimated' : 'Actual') : '-';
        departure.statusVessel = trackerEvent?.pol?.originDeparture ? (new Date() < new Date(trackerEvent?.pol?.originDeparture) ? 'Estimated' : 'Actual') : '-';

        resultTracker = [
            ...resultTracker,
            pol,
            departure,
        ]
        return resultTracker;
    }

    const EvergreenData = [
        {
            location: {
                country: "Malaysia",
                country_code: "MY",
                lng: 103.5468,
                locode: "MYTPP",
                name: "Tanjung Pelepas",
                id: 3,
                state: "Johor",
                lat: 1.358
            },
            dateLocation: '2021-09-05 UTC',
            statusLocation : 'Actual',
            icon: "icon-anchor port",
            port: "Arrival",
            vessel: {
                name: "EVER BLISS",
                imo: 9786932,
                id: 2,
                call_sign: "H9PP",
                flag: "PA",
                mmsi: 351465000
            }
        },
        {
            location: {
                country: "Taiwan",
                country_code: "TW",
                lng: 120.31333,
                locode: "TWKHH",
                name: "Kaohsiung",
                id: 4,
                state: "Kaohsiung",
                lat: 22.61626
            },
            dateLocation: '2021-09-11 UTC',
            statusLocation : 'Actual',
            icon: "icon-anchor port",
            port: "Arrival",
            vessel: {
                name: "EVER BLISS",
                imo: 9786932,
                id: 2,
                call_sign: "H9PP",
                flag: "PA",
                mmsi: 351465000
            }
        }
    ]

    const transitArray = () => {
        let transitPoint = locations?.filter(e => e?.id > 2);
        let selectedArray = transitPoint?.map(dt => {
            return {
                location : dt,
                icon: 'icon-anchor port',
                port: "Arrival",
                vessel: vessels?.find(item => trackPoint?.some(v => (v?.imo === item?.imo && v?.point1 === dt?.locode)))
            }
        });
        return selectedArray;
    }

    let resultTracker =  trackerArray().concat(trackerObject?.scac === "EGLV" ? EvergreenData : transitArray());
    const locationPod = locations?.find(e => e.id === 2);
    resultTracker = [
        ...resultTracker,
        {
            location : locationPod,
            vessel : trackerObject?.scac === "EGLV" ? {
                name: "A KIBO",
                imo: 9444962,
                id: 3,
                call_sign: "3ERD9",
                flag: "PA",
                mmsi: 370017000
            } : vessels?.find(item => trackPoint?.some(v => (v?.imo === item?.imo && v?.point1 === locationPod?.locode))),
            icon : 'icon-anchor port',
            portInfo :  trackerEvent?.pod?.portInfo,
            dateLocation : trackerEvent?.pod?.vesselArriver,
            showPortInfo : false,
            dateVessel : trackerEvent?.pod?.originArriver,
            statusLocation : trackerEvent?.pod?.vesselArriver ? (new Date() < new Date(trackerEvent?.pod?.vesselArriver) ? 'Estimated' : 'Actual') : '-',
            statusVessel : trackerEvent?.pod?.originArriver ? (new Date() < new Date(trackerEvent?.pod?.originArriver) ? 'Estimated' : 'Actual') : '-',
            port : "Arrival",
        }
       
    ]

    return (
        <>
        {resultTracker?.map((tracker) => (
            <div className="tr__latest-event-step d-flex flex-column">
                <i className={tracker?.icon}/>
                {tracker?.location && <h6 className="h6 mtx05 f-medium">{tracker?.location?.country ? `${tracker?.location?.country},`: ''} {tracker?.location?.name?.toUpperCase()} {tracker?.location?.locode ? `(${tracker?.location?.locode})` : '-'}</h6>}
                <p className={`${tracker?.location ? '' : 'mtx4'} mtbx1 f-medium`}>{tracker?.port}</p>
                <div className="tr__latest-event-step--date mbx1 d-flex align-items-center justify-content-between" >
                    <div className="d-flex align-items-center">
                            <i className={`${tracker?.portInfo ? 'mrx1' : 'text-spacing'} icon-satellite small-size`}/>
                            {tracker?.portInfo ? <i className="small-size icon-warning mr-2" onClick={() => {
                                setPortInfo(true);
                                tracker?.showPortInfo === true ? setChoosePol(true) : setChoosePod(true);
                            }} /> : '' } 
                            <h6 className="f-medium">{tracker?.dateLocation ? moment.utc(tracker?.dateLocation).format('DD MMM YYYY | hh:mm A') : 'N/A' }</h6>
                    </div>
                    <h6 className="f-medium mlx2">{tracker?.statusLocation}</h6>
                </div>
                <div className="tr__latest-event-step--date mbx1 d-flex align-items-center justify-content-between" >
                    <div className="d-flex align-items-center date">
                        <i className="text-spacing icon-ship small-size"/>
                        <h6 className="f-medium">{tracker?.dateVessel ? moment.utc(tracker?.dateVessel).format('DD MMM YYYY | hh:mm A') : 'N/A'}</h6>
                    </div>
                    <h6 className="f-medium mlx2">{tracker?.statusVessel}</h6>
                </div>
                {tracker?.vessel && <div className="tr__latest-event-step--date mbx1 d-flex align-center justify-content-between">
                    <h6 className="f-medium mrx2">Vessel: {tracker?.vessel?.name ? tracker?.vessel?.name : '-'} {tracker?.vessel?.imo ? `(${tracker?.vessel?.imo})` : ''}</h6>
                </div>}
            </div>
        ))}
        </>
    )
}